import React from "react";
import { Bell, Zap, Globe, Pause } from "lucide-react";
import type { PriceAlertStatsData } from "@/api/price-alerts";
import { StatCard } from "@/components/ui/StatCard";

interface PriceAlertStatsCardsProps {
  stats: PriceAlertStatsData | undefined;
  isLoading: boolean;
  className?: string;
}

/** Price alert stat cards in the redesign style; Paused shows only when something is paused. */
export const PriceAlertStatsCards: React.FC<PriceAlertStatsCardsProps> = ({
  stats,
  isLoading,
  className = "",
}) => {
  const value = (n: number | undefined) => (isLoading || !stats ? "–" : n);

  return (
    <div className={`-mx-4 flex gap-2 overflow-x-auto px-4 [scrollbar-width:none] lg:mx-0 lg:grid lg:grid-cols-3 lg:gap-4 lg:px-0 ${className}`}>
      <StatCard
        tone="green"
        icon={<Bell className="size-3.5" />}
        value={value(stats?.activeAlerts)}
        label="Active alerts"
      />
      <StatCard
        tone="orange"
        icon={<Zap className="size-3.5" />}
        value={value(stats?.triggered7d)}
        label="Triggered (7d)"
        extra={
          stats && stats.triggeredToday > 0 ? (
            <span className="text-xs font-medium text-[#4ade80]">
              ↑ {stats.triggeredToday} today
            </span>
          ) : undefined
        }
      />
      <StatCard
        tone="purple"
        icon={<Globe className="size-3.5" />}
        value={value(stats?.exchangesWatched)}
        label="Exchanges watched"
      />
      {stats && stats.paused > 0 && (
        <StatCard
          tone="red"
          icon={<Pause className="size-3.5" />}
          value={stats.paused}
          label="Paused"
        />
      )}
    </div>
  );
};
